// extracted by mini-css-extract-plugin
export default {"button":"InfoTooltipButton_button__p86Ht"};